import { create } from 'zustand';
import type { NoteData } from '@/(routers)/boards/editor/block/definitions/fields/fieldPianoRoll';

type SpeakerFieldRef = {
    setNotes: (notes: NoteData[]) => void;
    getNotes: () => NoteData[];
};

interface BlockModalSpeakerState {
    fieldRef: SpeakerFieldRef | null;
    setFieldRef: (ref: SpeakerFieldRef) => void;
    clearFieldRef: () => void;
}

export const useBlockModalSpeakerStore = create<BlockModalSpeakerState>((set) => ({
    fieldRef: null,
    setFieldRef: (ref) => set({ fieldRef: ref }),
    clearFieldRef: () => set({ fieldRef: null }),
}));
